import React from "react";
import PropTypes from "prop-types";
import Header from "components/Header/Header.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import HomeFooter from "components/Footer/HomeFooter.js";
import { Box, useTheme, useMediaQuery } from "@mui/material";

export default function PublicSiteLayout(props) {
  const {
    children,
    forceSolidHeader = false,
    darkMode,
    toggleDarkMode,
    themeMode,
    ...rest
  } = props;
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down("sm"));
  const HEADER_HEIGHT = isXs ? 45 : 55;
  const isHeroHeader = !forceSolidHeader;
  return (
    <Box
      sx={{
        position: "relative",
        minHeight: "100vh",
        bgcolor: "background.default",
        backgroundImage: "none",
      }}
    >
      <Header
        color="transparent"
        routes={[]}
        rightLinks={
          <HeaderLinks
            darkMode={darkMode}
            toggleDarkMode={toggleDarkMode}
            themeMode={themeMode}
          />
        }
        fixed
        forceSolid={forceSolidHeader}
        changeColorOnScroll={{
          height: 50, // Legacy support if needed, but forceSolid usually overrides
          color: "white",
        }}
        {...rest}
      />

      {/* Spacer applied only if header is forced solid (non-Home pages) */}
      {!isHeroHeader && (
        <Box
          aria-hidden="true"
          sx={{
            height: `calc(${HEADER_HEIGHT}px + env(safe-area-inset-top, 0px))`,
            flexShrink: 0,
            backgroundColor: "transparent",
          }}
        />
      )}

      <main
        style={{
          minHeight: "calc(100vh - 1px)",
        }}
      >
        {children}
      </main>

      <HomeFooter />
    </Box>
  );
}

PublicSiteLayout.propTypes = {
  children: PropTypes.node,
  forceSolidHeader: PropTypes.bool,
  darkMode: PropTypes.bool,
  toggleDarkMode: PropTypes.func,
};
